module.exports = __webpack_public_path__ + "img/SABER.8438fcf2.jpg";